import React from "react";
import { Tooltip } from "@pd/pd-ui-kit";
import { Control, Controller } from "react-hook-form";

import {
  OptionItem,
  PeriodFilterValues,
} from "~/pages/RegMen/PeriodFilter/lib";
import { filterOptionByLabel } from "~/shared/lib/filterHelpers";
import { Select } from "~/shared/ui/Select";

import s from "~/pages/RegMen/PeriodFilter/s.less";

interface SelectFieldProps {
  name: keyof PeriodFilterValues;
  control: Control<PeriodFilterValues>;
  label: string;
  options: OptionItem[];
  mode?: "multiple";
  showSearch?: boolean;
  allowClear?: boolean;
  onSearch?: (text: string) => void;
  onPopupScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

const SelectField = ({
  name,
  control,
  label,
  options,
  mode,
  showSearch = false,
  allowClear = false,
  onSearch,
  onPopupScroll,
}: SelectFieldProps) => (
  <div className={`${s.field} ${s[name]}`}>
    <span>{label}</span>
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <Select
          placeholder="Выберите"
          labelInValue
          mode={mode}
          options={options}
          showSearch={showSearch}
          allowClear={allowClear}
          filterOption={onSearch ? false : filterOptionByLabel}
          onSearch={onSearch}
          onPopupScroll={onPopupScroll}
          maxTagCount="responsive"
          maxTagPlaceholder={(omittedValues) => {
            const labels = omittedValues
              .map((item) => item?.label ?? item?.value ?? "")
              .join(", ");
            return (
              <Tooltip
                styles={{ root: { pointerEvents: "none" } }}
                title={labels}
                variant="secondary2"
                arrow={true}
              >
                <span>{`ещё ${omittedValues.length}`}</span>
              </Tooltip>
            );
          }}
          value={mode ? (Array.isArray(value) ? value : []) : value}
          onChange={onChange}
        />
      )}
    />
  </div>
);

export default SelectField;
